/** @format */

import {styled, Box, Card, Typography} from '@mui/material';

export const StyledCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'isGood',
})<{isGood: boolean}>(({theme, isGood}) => ({
  padding: theme.spacing(4),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.2s ease-in-out',
  backgroundColor: theme.palette.semantic_dark?.surface.surface1 || '#2D2E32',
  borderRadius: 0,
  '&:hover': {
    boxShadow: isGood
      ? `0 0 32px 0 ${theme.palette.semantic_dark?.good.container} inset`
      : `0 0 32px 0 ${theme.palette.semantic_dark?.bad.container} inset`,
  },
}));

export const HeaderRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '16px',
});

export const CampaignName = styled(Typography)(({theme}) => ({
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '20px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const SpentValue = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.primary.on,
  position: 'absolute',
}));

export const ChartContainer = styled(Box)(({theme}) => ({
  width: '100%',
  height: '80px',
  marginTop: theme.spacing(4),
}));

export const KpiContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  alignItems: 'flex-end',
  flexShrink: 0,
});

export const KpiRow = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '2px',
});

export const KpiLabel = styled(Typography)(({theme}) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
}));

export const KpiValue = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));

export const DeviationValue = styled(Typography, {
  shouldForwardProp: prop => prop !== 'valueColor',
})<{valueColor: string}>(({valueColor}) => ({
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  color: valueColor,
}));

export const SensorsList = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(4),
}));

export const SensorItem = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0),
}));

export const SensorName = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface.onSurface,
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const SensorCount = styled(Typography)(({theme}) => ({
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: '20px',
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  flexShrink: 0,
}));

export const NoSensorsErrorsSlug = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  height: '100%',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  marginTop: theme.spacing(4),
  color: theme.palette.semantic_dark?.surface.onSurface,
  backgroundImage: `
    repeating-linear-gradient(
      135deg,
      ${theme.palette.semantic_dark?.primary.container} 0px,
      ${theme.palette.semantic_dark?.primary.container} 1px,
      transparent 1px,
      transparent 8px
    )
  `,
}));
